export { default as KitDetails } from "./kitDetails";
